if (!customElements.get('feature-columns')) {
  class FeatureColumns extends HTMLElement {
    connectedCallback() {
      const columns = this.querySelectorAll('[data-fc-animate]');
      if (columns.length === 0) return;

      const prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

      if (prefersReducedMotion || !('IntersectionObserver' in window)) {
        columns.forEach((column) => column.classList.add('is-visible'));
        return;
      }

      const observer = new IntersectionObserver((entries, obs) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add('is-visible');
            obs.unobserve(entry.target);
          }
        });
      }, { threshold: 0.2 });

      columns.forEach((column) => observer.observe(column));
    }
  }

  customElements.define('feature-columns', FeatureColumns);
}
